export { default } from './InventoryItemList';

